export default __webpack_public_path__ + "static/media/STJT.12daa4fb.png";